module.exports = __webpack_public_path__ + "img/awards_image_10.b1301399.jpg";